import React from "react";

export const DynamicTag: React.FC<React.AllHTMLAttributes<HTMLElement>> = React.memo(({ type, children, ...props }: React.AllHTMLAttributes<HTMLElement>): JSX.Element => {
    return React.createElement(
        type || 'div',
        props,
        children
    );
});
